import { Button } from "@/components/ui/button";
import { AlertTriangle, AlertOctagon, Check, BellOff } from "lucide-react";

export default function AlarmPanel({ alarms, onAck, disabled }) {
  const active = alarms.filter((a) => a.active);
  const sorted = [...active].sort((a, b) => (a.severity === "critical" ? -1 : 1));

  return (
    <div className="bg-card border border-border/60 rounded-md flex flex-col h-full" data-testid="alarm-panel">
      <div className="px-3 py-2 border-b border-border/60 flex items-center justify-between bg-popover">
        <span className="label-ot">Alarm Panel</span>
        <span className="font-mono text-xs text-muted-foreground" data-testid="active-alarm-count">{active.length} ACTIVE</span>
      </div>
      <div className="flex-1 overflow-y-auto max-h-[300px]">
        {sorted.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-10 text-muted-foreground gap-2">
            <BellOff className="w-6 h-6" />
            <span className="text-xs font-mono">NO ACTIVE ALARMS</span>
          </div>
        ) : (
          sorted.map((a) => {
            const crit = a.severity === "critical";
            return (
              <div
                key={a.alarm_id}
                data-testid="alarm-row"
                className={`px-3 py-2.5 border-b border-border/40 flex items-center gap-3 ${
                  crit && !a.acknowledged ? "alarm-critical-blink border" : ""
                } ${crit ? "bg-status-critical/5" : "bg-status-warning/5"}`}
              >
                {crit ? <AlertOctagon className="w-4 h-4 text-status-critical shrink-0" /> : <AlertTriangle className="w-4 h-4 text-status-warning shrink-0" />}
                <div className="flex-1 min-w-0">
                  <div className="text-xs font-medium truncate">{a.description}</div>
                  <div className="font-mono text-[10px] text-muted-foreground">
                    {a.tag_id} · {a.severity.toUpperCase()} {a.acknowledged && "· ACK"}
                  </div>
                </div>
                {a.acknowledged ? (
                  <span className="text-[10px] font-mono text-status-normal flex items-center gap-1"><Check className="w-3 h-3" />ACK</span>
                ) : (
                  <Button
                    data-testid="ack-alarm-button"
                    size="sm"
                    disabled={disabled}
                    onClick={() => onAck(a.alarm_id)}
                    className="h-6 px-2 text-[10px] rounded-sm bg-secondary hover:bg-accent text-foreground"
                  >
                    ACK
                  </Button>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
